/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Install_Step_1Inputs */

const fr_install_step_1 = /** @type {(inputs: Install_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décompressez l'archive sur votre serveur web.`)
};

const en_install_step_1 = /** @type {(inputs: Install_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unzip the archive on your web server.`)
};

/**
* | output |
* | --- |
* | "Unzip the archive on your web server." |
*
* @param {Install_Step_1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const install_step_1 = /** @type {((inputs?: Install_Step_1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Install_Step_1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_install_step_1(inputs)
	return en_install_step_1(inputs)
});